import {AppstoreMainviewComponent} from "../appstore-mainview/appstore-mainview.component";
import {Component} from "@angular/core";

@Component({
    selector: 'mobile-appstore-mainview',
    template: require('./mobile-appstore-mainview.html'),
    styles: [require('./mobile-appstore-mainview.css')]
})
export class MobileAppstoreMainviewComponent extends AppstoreMainviewComponent 
{
}